import React, { useEffect, useRef, useState } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Icon } from "antd";
import ReactDOM from "react-dom";

const printFromUri = async uri => {
    if (!uri) return;

    try {
        const response = await fetch(uri);
        if (!response.ok) throw new Error("Falha ao obter o documento");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.src = blobUrl;

        iframe.onload = () => {
            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }, 300);
        };

        document.body.appendChild(iframe);

        setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(blobUrl);
        }, 60000);
    } catch (err) {
        console.error("Erro ao imprimir:", err);
        window.open(uri, "_blank");
    }
};

const MyHeader = (state, previousDocument, nextDocument) => {
    if (!state.currentDocument || state.documents.length <= 1) {
        return null;
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                padding: "8px",
                width: "100%"
            }}
        >
            <button type="button" onClick={previousDocument} disabled={state.currentFileNo === 0}>
                Documento Anterior
            </button>

            <button type="button" onClick={nextDocument} disabled={state.currentFileNo >= state.documents.length - 1}>
                Próximo Documento
            </button>
        </div>
    );
};

const SemVisualizador = () => <span>Não foi possível carregar o documento.</span>;

const Viewer = ({ docs = [] }) => {
    const containerRef = useRef(null);
    const [selectedUri, setSelectedUri] = useState(null);

    const documentoAtual = docs.find(documento => documento.uri === selectedUri) || docs[0];

    const uriAtual = documentoAtual?.uri;

    useEffect(() => {
        const container = containerRef.current;

        if (!container || !uriAtual) return;

        const botao = document.createElement("a");

        ReactDOM.render(<Icon type="printer" style={{ fontSize: "20px", color: "#000", opacity: 1 }} />, botao);

        Object.assign(botao.style, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: "0",
            width: "30px",
            height: "30px",
            marginLeft: "0",
            marginRight: "5px",
            padding: "0",
            border: "0",
            cursor: "pointer",
            textDecoration: "none",
            borderRadius: "50%",
            backgroundColor: "#fff",
            color: "#000",
            boxShadow: "2px 2px 3px #00000033",
            fontSize: "18px"
        });

        const imprimir = () => printFromUri(uriAtual);

        botao.addEventListener("click", imprimir);

        const inserirBotao = () => {
            const controlos = container.querySelector("#pdf-controls");

            if (!controlos) return;

            if (controlos.firstElementChild !== botao) {
                controlos.prepend(botao);
            }
        };

        const observer = new MutationObserver(inserirBotao);

        observer.observe(container, {
            childList: true,
            subtree: true
        });

        inserirBotao();

        return () => {
            observer.disconnect();
            botao.removeEventListener("click", imprimir);

            ReactDOM.unmountComponentAtNode(botao);
            botao.remove();
        };
    }, [uriAtual]);

    return (
        <div ref={containerRef} style={{ height: "100vh", width: "100%" }}>
            <DocViewer
                documents={docs}
                activeDocument={documentoAtual}
                onDocumentChange={documento => setSelectedUri(documento?.uri || null)}
                pluginRenderers={DocViewerRenderers}
                language="pt"
                config={{
                    header: {
                        overrideComponent: MyHeader,
                        disableFileName: true
                    },
                    pdfZoom: {
                        defaultZoom: 0.8
                    },
                    noRenderer: {
                        overrideComponent: SemVisualizador
                    }
                }}
            />
        </div>
    );
};

export default Viewer;
